// extracted by mini-css-extract-plugin
export default {"container":"AffectedSwitchesList_container__OubMI","infoBox":"AffectedSwitchesList_infoBox__84UDR","backButton":"AffectedSwitchesList_backButton__+Pfim"};